import FulltextWrapper from '~/components/organisms/fulltext/FulltextWrapper';
import { QuerySetContextProvider } from '~/contexts/QuerysetContext';
import { useSERPActions } from '~/core/state/actions/SERPActionsContext';
import { useSERPState } from '~/core/state/SERPStateContext';
import { useFullTextResults } from '~/hooks/useFulltextResults';
import { useDynamicComponents } from '~/plugins/dynamicComponents/dynamicComponentsContext';
import SRError from '~/utils/errors/srError';

type FulltextContainerProps = {
    isInsideProducts: boolean;
    isFulltextOnly: boolean;
};

const FulltextContainer = ({ isInsideProducts, isFulltextOnly }: FulltextContainerProps) => {
    const { loadMore, updateIndexFilterControls, handleGoToResult } = useSERPActions();
    const { controls } = useSERPState();
    const { FullText, FulltextResultHeading, FulltextResultWrapper } = useDynamicComponents();
    const { fullTextResults } = useFullTextResults();

    return (
        <FulltextWrapper>
            {fullTextResults.map((set, i) => {
                const state = set.state;
                const setResults = set.result;
                const id = state.querySet.identifier;
                const setControls = controls.find((c) => c.querySet.identifier === id);

                if (!setControls) {
                    throw new SRError(
                        'No controls object found for Fulltext set: ${set.querySetIdentifier}. Error occured in state construction.'
                    );
                }

                if (!setResults) {
                    throw new SRError(
                        'No results object found for Fulltext set: ${set.querySetIdentifier}. Error occured in state construction.'
                    );
                }

                const appliedIndicesFilters = setControls.indices?.filter((index) => index.isChecked) ?? [];

                if (
                    setResults.hits.length === 0 &&
                    state.setting.showZeroResults === false &&
                    appliedIndicesFilters.length === 0
                ) {
                    return null;
                }

                return (
                    <QuerySetContextProvider
                        key={set.result.querySetIdentifier}
                        state={set.state}
                        querySetId={set.result.querySetIdentifier}
                    >
                        <FullText
                            set={state}
                            results={setResults}
                            controls={setControls}
                            showLoadMore={setResults.totalRecords > setResults.hits.length}
                            loadMore={() =>
                                loadMore({
                                    querySetIdentifier: id,
                                    from: setResults.hits.length,
                                })
                            }
                            updateIndexFilterControls={updateIndexFilterControls}
                            isInsideProducts={isInsideProducts}
                            title={state.querySet.name}
                            hasIcons={undefined !== state.useIcons ? state.useIcons : false}
                            key={i}
                            handleGoToResult={handleGoToResult}
                            isFulltextOnly={isFulltextOnly}
                            renderProps={{
                                FulltextResultHeading,
                                FulltextResultWrapper,
                            }}
                        />
                    </QuerySetContextProvider>
                );
            })}
        </FulltextWrapper>
    );
};

export default FulltextContainer;
